import SHA256 from 'crypto-js/sha256';
import Base64 from 'crypto-js/enc-base64';
import Core from 'crypto-js/core';
import { PKCE_CONSTANTS } from '../constants/PKCEConstants';
import { AES, enc } from 'crypto-js';
import { getStateCodeSpecificUrlUsingProcessEnv } from './navigationHelper';
const { sessionKey } = getStateCodeSpecificUrlUsingProcessEnv();

export const base64UrlEncode = (words: any) => {
  return Base64.stringify(words)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};

export const getPKCEVerifier = () => {
  return Base64.stringify(Core.lib.WordArray.random(50))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};

export const getPKCEChallenge = (verifier = '') => {
  return base64UrlEncode(SHA256(verifier));
};

export const base64DecodeJwtPayload = (jwtAccessToken: string) => {
  if (jwtAccessToken) {
    const base64Url = jwtAccessToken.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => {
          return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  }
  return undefined;
};

export const generateRandomWord = (length?: number) => {
  return Base64.stringify(
    Core.lib.WordArray.random(
      length ?? PKCE_CONSTANTS.DEFAULT_RANDOM_CODE_GENERATE_LENGTH,
    ),
  );
};

export const getEncryptedValue = (value: string): string => {
  const encryptedType = AES.encrypt(value, sessionKey);
  return encryptedType.toString();
};

export const getDecryptedValue = (value: string): string => {
  const decryptedType = AES.decrypt(value, sessionKey).toString(enc.Utf8);
  return decryptedType;
};
